import { defineMessages } from 'react-intl';

export default defineMessages({
  home: {
    id: 'home',
    defaultMessage: 'Home',
  },
  partnerDetail: {
    id: 'partnerDetail',
    defaultMessage: 'Partner Management',
  },

  info: {
    title: {
      id: 'partnerDetail.info',
      defaultMessage: 'Partner Basic Information Details',
    },
    name: {
      id: 'partnerDetail.info.name',
      defaultMessage: 'Partner Name',
    },
    id: {
      id: 'partnerDetail.info.id',
      defaultMessage: 'Partner ID',
    },
    logo: {
      id: 'partnerDetail.info.logo',
      defaultMessage: 'Partner Logo',
    },
    created: {
      id: 'partnerDetail.info.created',
      defaultMessage: 'Created On',
    },
    updated: {
      id: 'partnerDetail.info.updated',
      defaultMessage: 'Updated On',
    },
  },

  service: {
    title: {
      id: 'partnerDetail.service',
      defaultMessage: 'Partner Service Type Details',
    },
    basicInformation: {
      id: 'partnerDetail.service.basicInformation',
      defaultMessage: 'Service Basic Information',
    },
    packageTypeDesc: {
      id: 'partnerDetail.service.packageTypeDesc',
      defaultMessage: 'Service Package Type Description',
    },
    name: {
      id: 'partnerDetail.service.name',
      defaultMessage: 'Service Type',
    },
    type: {
      id: 'partnerDetail.service.type',
      defaultMessage: 'Service Type',
    },
    eta: {
      id: 'partnerDetail.service.eta',
      defaultMessage: 'Service ETA',
    },
    tag: {
      id: 'partnerDetail.service.tag',
      defaultMessage: 'Service Tag',
    },
    time: {
      id: 'partnerDetail.service.time',
      defaultMessage: 'Active Hours',
    },
    enabled: {
      id: 'partnerDetail.service.enabled',
      defaultMessage: 'Service Enabled',
    },
  },
  tnc: {
    id: 'partnerDetail.tnc',
    defaultMessage: 'Partner’s Terms & Condition',
  },

  btn: {
    viewTnC: {
      id: 'partnerDetail.viewTnC',
      defaultMessage: 'Add / View Terms & Condition',
    },
    back: {
      id: 'btn.back',
      defaultMessage: 'Back',
    },
    edit: {
      id: 'btn.edit',
      defaultMessage: 'Edit',
    },
    update: {
      id: 'btn.update',
      defaultMessage: 'Update',
    },
    save: {
      id: 'btn.save',
      defaultMessage: 'Save',
    },
    cancel: {
      id: 'btn.cancel',
      defaultMessage: 'Cancel',
    },
  },
  mandatory: {
    id: 'mandatory',
    defaultMessage: '(*) Mandatory Field',
  },
});
